// import collaboration from './list/collaboration';
import referrerApproval from './list/referrerApproval';
import potentialPartner from './list/potentialPartner';
import revenue from './list/revenue';
import payableRevenue from './list/payableRevenue';
import user from './list/user';
import validate from './list/validate';
import object from './list/object';
import channel from './list/channel';
import payment from './list/payment';
import departmentChannels from './list/departmentChannels';
import partnerInvites from './list/partnerInvites';
import reviewChannel from './list/reviewChannel';
import deactivateCheck from "./component/deactivateCheck";

const Nagato = {
  list: {
    // collaboration: collaboration,
    referrerApproval: referrerApproval,
    potentialPartner: potentialPartner,
    revenue: revenue,
    payableRevenue: payableRevenue,
    user: user,
    validate: validate,
    object: object,
    channel: channel,
    payment: payment,
    departmentChannels: departmentChannels,
    partnerInvites: partnerInvites,
    reviewChannel: reviewChannel,
  },
  component: {
    deactivateCheck: deactivateCheck,
  }
};

export {Nagato};
